export const getMappedKey = (priceKey: string) => {
  switch (priceKey) {
    case '1':
      return 'price1m'
    case '12':
      return 'price12m'
    case '24':
      return 'price24m'
    case '36':
      return 'price36m'
    default:
      return ''
  }
}

export const getMappedMonthKey = (priceKey: string) => {
  switch (priceKey) {
    case 'price1m':
      return 1
    case 'price12m':
      return 12
    case 'price24m':
      return 24
    case 'price36m':
      return 36
    default:
      return 0
  }
}
